import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Message, MessageService } from 'primeng/api';
import { CognitoException } from 'src/app/model/enum/cognito-exception';
import { AuthService } from 'src/app/service/auth.service';
import { CustomValidator } from 'src/shared/custom-validator';
import { GeolocationService } from 'src/app/service/geolocation.service';
import { GlobalService } from 'src/app/service/global.service';
import { Language } from 'src/app/model/language';
import { LANGUAGE_LIST } from 'src/app/model/mockup/language-mockup';
import { LanguageEnum } from 'src/app/model/enum/language-enum';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnInit {
  codeParameter: string = "";
  public form!: FormGroup;
  public formCode!: FormGroup;
  public formPass!: FormGroup;

  email: string;
  code: string;
  password: string;
  passwordConfirm: string;
  isDivEmail: string;
  isDivCode: string;
  isDivPass: string;
  isNotDivPass: string;
  loginUrl: string;
  messagesEmail: Message[]
  messagesCode: Message[]
  messagesCodeFix: Message[]
  messagesPass: Message[]
  submitBtnLoading: boolean = false;

  languageOptions: Language[];
  DEFAULT_LANGUAGE: Language;
  lastLanguage: Language;
  language: Language;
  countdown: number = 60; 
  isButtonDisabled: boolean = true;
  languageCode: string | null;
  private intervalId: any;
  


footerBackground: string = "url('assets/img/dashboard/Header.svg')";
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private titleService: Title,
    private translocoService: TranslocoService,
    private geolocationService: GeolocationService,
    private globalService: GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute) {

    this.email="";
    this.code="";
    this.password="";
    this.passwordConfirm="";
    this.isNotDivPass=""
    this.isDivEmail="none";
    this.isDivCode="none";
    this.isDivPass="none";
    this.loginUrl = '/login';
    this.messagesEmail = [];
    this.messagesCode = [];
    this.messagesCodeFix = [];
    this.messagesPass = [];

    this.languageOptions = LANGUAGE_LIST as [];
  // Fallback padrão EN_US
  this.DEFAULT_LANGUAGE = this.languageOptions[1];
    this.language = this.DEFAULT_LANGUAGE;
    this.lastLanguage = this.DEFAULT_LANGUAGE;
    this.languageCode = null;
  }

  ngOnInit(): void {
    this.createForm(this.email);
    this.createFormCode(this.code);
    this.createFormPass(this.password, this.passwordConfirm);

    this.languageCode = this.normalizeLanguage(sessionStorage.getItem("language"));
    if (this.languageCode !== LanguageEnum.PT_BR && this.languageCode !== LanguageEnum.EN_US && this.languageCode !== LanguageEnum.ES_ES) {
      this.getLocation();
    } else {
      sessionStorage.setItem('language', this.languageCode);
      this.language = this.getLanguage(this.languageCode);
      this.changeLanguage(this.language.name);
    }
    
    this.refreshLanguageOptions();
    this.setTitle();
    this.startCountdown();

    this.form.controls['email'].valueChanges.subscribe(value => {
      if (value) {
        this.form.controls['email'].setValue(value.toLowerCase(), { emitEvent: false });
      }
    });


  this.route.queryParams.subscribe(params => {
      this.codeParameter = params['code'];
      this.email = params['email']; 


      if(this.codeParameter && this.codeParameter.length === 6 && this.email && this.email.length > 0) {
        this.showPass();
        this.submitCodeWithParam(this.codeParameter, this.email);
      }else{
        this.showEmail();
      }
    });
  }

  startCountdown(): void {
    this.isButtonDisabled = true;
    this.countdown = 60;

    this.intervalId = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        this.isButtonDisabled = false;
        clearInterval(this.intervalId);
      }
    }, 1000);
  }

  async onSubmit() {
    if(this.form.valid) {
      this.submitBtnLoading = true;
      
      this.globalService.FindUseEmail(this.f.email.value).subscribe({
        next: (_user)=> {
          this.authService.forgotPassword(this.f.email.value).then(() => {
            this.email = this.maskEmail(this.f.email.value);
            this.submitBtnLoading = false;
            this.showCode();
          }).catch(error => {
            let messageError = '';
            if(CognitoException.USER_NOT_FOUND === error.name)
              this.translocoService.selectTranslate('user.forgotPassword.emailValid').subscribe(
                value => messageError = value
              );
            if(messageError.length < 1)
              messageError = error;
            this.submitBtnLoading = false;
            this.showMessage('error', messageError)
          });
        },
        error: _=>{
          this.submitBtnLoading = false;
          this.f.email.markAsDirty()
          this.translocoService.selectTranslate('user.forgotPassword.emailValid').subscribe(value => 
            this.showMessage('error', value)
          );          
        }
      });
    } else {
      this.f.email.markAsDirty()
      this.translocoService.selectTranslate('inputRequired').subscribe(value => 
        this.showMessage('error', value)
      
    );
    }
  }


  async submitCodeWithParam(code: string, email:string) {
    if(String(code).length === 6) {
      this.submitBtnLoading = true;
      await this.authService.confirmForgotPassword(email, '111111', code).then(() => {
        this.translocoService.selectTranslate('inputRequired').subscribe(value => 
          this.showMessage('success', value)
       
      );
      }).catch(error => {
        if(CognitoException.INVALID_PASSWORD === error.name) {
          this.showPass();
        } else if(CognitoException.CODE_MISMATCH === error.name) {
          this.resetFormCode()
          this.showEmail();
          this.translocoService.selectTranslate('user.forgotPassword.codeMismatch').subscribe(value => 
            this.showMessage('error', value)
        
        );          
        } else if(CognitoException.EXPIRED_CODE === error.name) {
          this.resetFormCode()
          this.showCode();
          this.translocoService.selectTranslate('user.forgotPassword.expiredCode').subscribe(value => 
            this.showMessage('error', value)
         
        );
        }else if(CognitoException.LIMIT_EXCEEDED === error.name)  {
           this.resetFormCode()
          this.showEmail();
          this.translocoService.selectTranslate('user.forgotPassword.limitExceeded').subscribe(value => 
            this.showMessage('error', value)
          );
        }
        else {
          this.resetFormCode()
          this.showCode();
          this.messagesPass = [{ severity: 'error', summary: error}]
        }
        this.submitBtnLoading = false;
      });
    } else {
      this.fc.code.markAsDirty()
      this.translocoService.selectTranslate('inputRequired').subscribe(value => 
        this.showMessage('error', value)
      
    );
    }
  
  }



  async onSubmitPass() {
    if(this.fp.password.invalid) this.fp.password.markAsDirty()
    if(this.fp.passwordConfirm.invalid) this.fp.passwordConfirm.markAsDirty()
    
    
      this.submitBtnLoading = true;
      await this.authService.confirmForgotPassword(this.email, this.fp.password.value, this.codeParameter).then(() => {
        this.translocoService.selectTranslate('user.forgotPassword.msgSuccess').subscribe(value => 
          this.showMessage('success', value)
      
        );
        setTimeout(() => {
          this.submitBtnLoading = false;
          const payload = `${this.email}:${this.fp.password.value}`;

          // Converte para Base64
          const encoded = btoa(payload);

           // Redireciona com query param
          this.router.navigate([this.loginUrl], { queryParams: { code: encoded } });

        }, 3000);  //3s
      }).catch(error => {
        if(CognitoException.INVALID_PASSWORD === error.name) {
          this.translocoService.selectTranslate('user.forgotPassword.invalidPassword').subscribe(value =>
             this.showMessage('error', value) 
          
        );
        } else if(CognitoException.CODE_MISMATCH === error.name) {
          this.resetFormCode()
          this.showCode();
          this.translocoService.selectTranslate('user.forgotPassword.codeMismatch').subscribe(value => 
            this.showMessage('error', value)
          
        );          
        } else if(CognitoException.EXPIRED_CODE === error.name) {
          this.resetFormCode()
          this.showCode();
          this.translocoService.selectTranslate('user.forgotPassword.expiredCode').subscribe(value => 
            this.showMessage('error', value)
          
        );
        }
        else if(CognitoException.LIMIT_EXCEEDED === error.name)  {
           this.resetFormCode()
          this.showEmail();
          this.translocoService.selectTranslate('user.forgotPassword.limitExceeded').subscribe(value => 
            this.showMessage('error', value)
          );
        
        } else {
          this.resetFormCode()
          this.showCode();
          this.showMessage('error', error)
          this.messagesPass = [{ severity: 'error', summary: error}]
        }
        this.submitBtnLoading = false;
      });
    
  }

  equalsPassword() : boolean {
    if(this.fp.password.value !== this.fp.passwordConfirm.value) {
      this.translocoService.selectTranslate('user.createAccount.passwordEquals').subscribe(value => 
        // this.messagesPass = [{ severity: 'error', summary: value }]
        this.showMessage('error', value)
      );
      return false;
    } else if(this.fp.password.invalid || this.fp.passwordConfirm.invalid) {
      this.translocoService.selectTranslate('user.forgotPassword.invalidPassword').subscribe(value => 
        // this.messagesPass = [{ severity: 'error', summary: value }]
        this.showMessage('error', value)
      );
      return false;
    }
    return true;
  }

  createForm(email: string) {
    this.form = this.formBuilder.group({
      email: [email, CustomValidator.getEmail()],
      language: [sessionStorage.getItem("language") ?? 'en-us']
    })
  }
  createFormCode(code: string) {
    this.formCode = this.formBuilder.group({
      code: [code, CustomValidator.getRequired()]
    })
  }
  createFormPass(password: string, passwordConfirm: string) {
    this.formPass = this.formBuilder.group({
      password: [password, CustomValidator.getPassword()],
      passwordConfirm: [passwordConfirm, CustomValidator.getPassword()]
    })
  }
  resetFormCode() {
    this.formCode.reset();
  }
  resetFormPass() {
    this.formPass.reset();
  }

  createFixMessage() {
    this.translocoService.selectTranslate('user.forgotPassword.msg').subscribe(value => 
      this.showMessage('success', value)
    //   this.messagesCodeFix = [
    //   { severity: 'success', summary: value}
    // ]
  );
  }

  backLogin() {
    this.router.navigate([this.loginUrl]);
  }

  async sendEmailAgain() {
    if (!this.isButtonDisabled) {
        await this.authService.resendConfirmationCode(this.f.email.value).then(() => {
        }).catch(() => {
          this.translocoService.selectTranslate('errorConection').subscribe(value => 
            this.showMessage('error', value)
          //   this.messagesCode = [
          //   { severity: 'error', summary: value}
          // ]
        );
        });
        this.startCountdown();
    }
  }
  
  showEmail() {
    this.isNotDivPass = ""
    this.isDivEmail = "";
    this.isDivCode = "none";
    this.isDivPass="none";
    this.messagesEmail = [];
  }

  showCode() {
    this.isNotDivPass = ""
    this.isDivEmail = "none";
    this.isDivCode = "";
    this.isDivPass="none";
    this.messagesCode = [];
    this.createFixMessage();
  }

  showPass() {
    this.isNotDivPass = "none"
    this.isDivEmail = "none";
    this.isDivCode = "none";
    this.isDivPass="";
    this.messagesPass = [];
  }

  maskEmail(email: string) {
    return email.substring(0,1)+
          '*****@***'+
          email.substring(email.length - 2);
  }

  setTitle() {
    this.translocoService.selectTranslate('title.forgot-password').subscribe(value => 
      this.titleService.setTitle(value)
    );
  }

  fixLanguage() {
    this.messageService.clear()
    this.language = this.f.language.value;
    if (this.lastLanguage !== this.language) {
      this.languageOptions
        .filter((opt) => opt.name === this.language.name)
        .map((cty) => (cty.disabled = true));
      this.languageOptions
        .filter((opt) => opt.name !== this.language.name)
        .map((cty) => (cty.disabled = false));

      this.lastLanguage = this.language;
      this.changeLanguage(this.language.name);
      sessionStorage.setItem("language", this.language.name);
    }
  }

  getLanguage(lan: string | null): Language {
    for (let i = 0; i < this.languageOptions.length; i++) {
      if (this.languageOptions[i].name === lan) {
        return this.languageOptions[i];
      }
    }
    return this.DEFAULT_LANGUAGE; // EN_US
  }

  private normalizeLanguage(lan: string | null): string {
    const allowed = [LanguageEnum.PT_BR, LanguageEnum.EN_US, LanguageEnum.ES_ES];
    if (!lan || !allowed.includes(lan as LanguageEnum)) {
      return LanguageEnum.EN_US;
    }
    return lan as string;
  }

  public changeLanguage(languageCode: string | null): void {
    if(languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  getLocation(){
    this.geolocationService.getCountry().subscribe({
      next: (data: any) => {
        // Só ajusta se ainda não foi definida por sessionStorage válido
        if (!(this.languageCode === LanguageEnum.PT_BR || this.languageCode === LanguageEnum.EN_US || this.languageCode === LanguageEnum.ES_ES)) {
          if (data.country_code === "BR") {
            this.language = this.languageOptions[0];
          } else {
            this.language = this.languageOptions[1];
          }
          sessionStorage.setItem('language', this.language.name);
          this.changeLanguage(this.language.name);
          this.refreshLanguageOptions();
        }
      },
      error: (_) => {
        if (!(this.languageCode === LanguageEnum.PT_BR || this.languageCode === LanguageEnum.EN_US || this.languageCode === LanguageEnum.ES_ES)) {
          // fallback EN_US
          this.language = this.DEFAULT_LANGUAGE;
          sessionStorage.setItem('language', this.language.name);
          this.changeLanguage(this.language.name);
          this.refreshLanguageOptions();
        }
      }
    });
  }

  refreshLanguageOptions() {
    for (let i = 0; i < this.languageOptions.length; i++) {
      if (this.languageOptions[i].name === this.language.name)
        this.languageOptions[i].disabled = true;
      else this.languageOptions[i].disabled = false;
    }
  }

private showMessage(
  severity: 'success' | 'error' | 'info' | 'warn',
  summary: string
): void {
  this.messageService.clear();
  this.messageService.add({
    key: 'toastMessages',
    severity,
    summary
  });
}

  get f() { return this.form.controls; }

  get fc() { return this.formCode.controls; }

  get fp() { return this.formPass.controls; }

  
}
